
import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

const SainikSadan = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faBuilding} className="me-2" />
            Integrated Sainik Sadan
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faBuilding} className="me-2" />
              About Integrated Sainik Sadans
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                Integrated Sainik Sadans in Haryana are Comprehensive, one-stop complexes being developed by the state government to provide essential services, welfare and accommodation to ex-servicemen, war widows, and their families.
              </p>
            </div>
            
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                These modern, multi-storey buildings combine ECHS polyclinics, CSD canteens, District Sainik Welfare offices, rest houses and common halls under one roof to ensure efficient accessible support.
              </p>
            </div>
            
            <div className="mb-0">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                These Sadans will be constructed in a phased manner in all districts of Haryana.
              </p>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default SainikSadan;
